import { motion } from "framer-motion";
import { Check, Zap } from "lucide-react";
import { PACKAGES, scrollToId } from "../lib/site";

export default function Pricing({ selected, onSelect }) {
  const choose = (id) => {
    onSelect(id);
    scrollToId("pasang");
  };

  return (
    <section id="paket" data-testid="pricing-section" className="relative pb-4 pt-4 sm:pb-6 sm:pt-6">
      <div className="pointer-events-none absolute left-1/2 top-0 h-[400px] w-[600px] -translate-x-1/2 rounded-full bg-[#1E5AA8]/15 blur-[160px]" />
      <div className="relative mx-auto max-w-7xl px-5 lg:px-8">
        <motion.p
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          className="font-mono text-xs tracking-[0.25em] text-cyan-400"
        >
          PAKET INTERNET
        </motion.p>
        <motion.h2
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ delay: 0.1 }}
          className="mt-4 font-display text-2xl font-extrabold tracking-tight text-white sm:text-3xl lg:text-4xl"
        >
          Pilih kecepatanmu.
        </motion.h2>
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ delay: 0.18 }}
          className="mt-4 max-w-xl text-base text-slate-300"
        >
          Semua paket <span className="font-bold text-[#FF6B35]">gratis biaya pemasangan</span>, unlimited
          tanpa FUP, dan sudah termasuk router Wi-Fi fiber.
        </motion.p>

        <div className="mt-14 grid gap-6 lg:grid-cols-3">
          {PACKAGES.map((p, i) => (
            <motion.article
              key={p.id}
              data-testid={`product-card-${p.id}`}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ delay: i * 0.12, duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
              style={{
                borderColor: `${p.color}66`,
                boxShadow: `0 0 44px ${p.color}26`,
                "--beam": p.color,
                "--beam-delay": `${i * -1.7}s`,
              }}
              className={`group fiber-beam relative flex flex-col rounded-3xl border-2 bg-[#0A1124]/80 backdrop-blur-xl transition-shadow duration-300 ${
                p.popular ? "lg:-translate-y-4" : ""
              }`}
            >
              <div className="relative aspect-[16/7] overflow-hidden rounded-t-[1.3rem]">
                <img
                  src={p.image}
                  alt={`Paket ${p.name}`}
                  data-testid={`product-image-${p.id}`}
                  className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#0A1124] via-transparent to-transparent" />
                <span
                  className="absolute left-4 top-4 rounded-full px-3 py-1 font-mono text-[11px] font-bold"
                  style={{ background: p.color, color: p.textOn }}
                >
                  {p.badge}
                </span>
              </div>

              <div className="relative z-10 -mt-9 flex justify-center">
                <div
                  data-testid={`speed-ring-${p.id}`}
                  className="fiber-beam relative flex h-[72px] w-[72px] items-center justify-center rounded-full border-2 bg-[#050914] transition-transform duration-300 group-hover:scale-110"
                  style={{
                    borderColor: p.color,
                    boxShadow: `0 0 24px ${p.glow}, inset 0 0 16px ${p.color}33`,
                    "--beam": p.color,
                    "--beam-speed": "4s",
                    "--beam-delay": `${i * -1.3}s`,
                  }}
                >
                  <div className="text-center">
                    <p className="font-display text-xl font-extrabold leading-none" style={{ color: p.color }}>
                      {p.speed}
                    </p>
                    <p className="mt-0.5 font-mono text-[9px] uppercase tracking-wider text-slate-400">Mbps</p>
                  </div>
                </div>
              </div>

              <div className="flex flex-1 flex-col px-5 pb-4 pt-2">
                <h3 className="font-display text-lg font-bold text-white">{p.name}</h3>
                <p className="mt-0.5 text-xs text-slate-400">
                  {p.tagline} • {p.ideal}
                </p>
                <p className="mt-2">
                  <span className="text-xs text-slate-400">Rp</span>{" "}
                  <span className="font-display text-3xl font-extrabold text-white">{p.price}</span>
                  <span className="ml-1 text-xs text-slate-400">/bulan</span>
                </p>
                <ul className="mt-3 flex-1 space-y-1.5">
                  {p.features.map((f) => (
                    <li key={f} className="flex items-start gap-2 text-xs text-slate-300">
                      <Check className="mt-0.5 h-3.5 w-3.5 shrink-0" style={{ color: p.color }} />
                      {f}
                    </li>
                  ))}
                </ul>
                <button
                  data-testid={`btn-select-${p.id}`}
                  onClick={() => choose(p.id)}
                  style={{ background: p.color, color: p.textOn }}
                  className="mt-4 inline-flex w-full items-center justify-center gap-2 rounded-full py-2.5 text-sm font-bold transition-all duration-200 hover:brightness-110"
                >
                  <Zap className="h-4 w-4" />
                  {selected === p.id ? "Paket Terpilih — Lanjut Daftar" : "Pilih Paket & Pasang"}
                </button>
              </div>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
}
